import React from 'react'
import { X } from "lucide-react"
import styles from "../../../components/ui/dialog.module.css"

export const ResumeModal = ({ application, isOpen, onClose }) => {
  if (!isOpen || !application) return null

  const { resume, coverLetter } = application

  return (
    <div className={styles.dialogOverlay} onClick={onClose}>
      <div className={styles.dialogContent} onClick={(e) => e.stopPropagation()}>
        <div className={styles.dialogHeader}>
          <h2 className={styles.dialogTitle}>Application Details</h2>
          <button onClick={onClose} className={styles.closeButton} aria-label="Close">
            <X size={24} />
          </button>
        </div>
        <div className={styles.dialogBody}>
          <h3 className="text-lg font-semibold mb-2">Cover Letter</h3>
          <p className="mb-4 whitespace-pre-wrap">{coverLetter}</p>

          <h3 className="text-lg font-semibold mb-2">Resume</h3>
          <div className="space-y-2">
            <p>
              <strong>Title:</strong> {resume.title}
            </p>
            <p>
              <strong>Summary:</strong> {resume.summary}
            </p>
            <p>
              <strong>Experience:</strong> {resume.experience}
            </p>
            <p>
              <strong>Education:</strong> {resume.education}
            </p>
            <p>
              <strong>Skills:</strong> {resume.skills}
            </p>
            <p>
              <strong>Certifications:</strong> {resume.certifications}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

